import { ControllerRenderProps, FieldPath, FieldValues, Select } from '@otp/ui';
import { useMemo } from 'react';
import { usePrograms } from 'src/hooks/query/use-programs';
import { useTranslation } from 'react-i18next';

type ProgramsProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  field: ControllerRenderProps<TFieldValues, TName>;
  hasError?: boolean;
};

export const ProgramsField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  disabled = false,
  className,
  placeholder,
  field,
  hasError,
}: ProgramsProps<TFieldValues, TName>) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'lms.curriculum.form.fields',
  });
  const { programs } = usePrograms();

  const options = useMemo(
    () =>
      (programs || []).map((entity) => ({
        value: entity.id,
        name: entity.name || '',
      })),
    [programs],
  );

  const defaultValue = field.value;

  return (
    <Select
      key={field.value}
      fullWidth={true}
      className={className}
      options={options}
      placeholder={placeholder || t('program')}
      defaultValue={defaultValue}
      error={hasError}
      {...field}
      value={undefined}
      ref={undefined}
      inputRef={field.ref}
      disabled={disabled}
    />
  );
};
